import Vue from "vue";

Vue.component("InputTaxId", () => import("./components/element/InputTaxId"));

Vue.component("InputBranchId", () => import("./components/element/InputBranchId"));

Vue.component("buttonStyle", () => import("./components/element/ButtonStyle"));

Vue.component("ButtonDropdown", () => import("./components/element/ButtonDropdown"));

Vue.component("CheckBox", () => import("./components/element/CheckBox"));

Vue.component("inputComponent", () => import("./components/element/inputComponent"));

Vue.component("TextArea", () => import("./components/element/TextArea"));

Vue.component("Radio", () => import("./components/element/Radio"));

Vue.component("CustomSwitch", () => import("./components/element/CustomSwitch"));

Vue.component("inputDropdown", () => import("./components/element/InputDropdown"));

Vue.component("inputDropdownV2", () => import("./components/element/inputDropdownV2"));

Vue.component("Tooltip", () => import("./components/element/Tooltip"));

Vue.component("MenuDropdown", () => import("./components/element/MenuDropdown"));

Vue.component("Noti", () => import("./components/notification/Noti"));

Vue.component("SwitchLang", () => import("./components/switchLang/SwitchLang"));

Vue.component("SwitchLangShowAll", () => import("./components/switchLang/SwitchLangShowAll"));

Vue.component("CalendarDrag", () => import("./components/calendar/CalendarDrag"));

Vue.component("CalendarSinglePicker", () => import("./components/calendar/CalendarSinglePicker"));

Vue.component("CalendarMonthandyear", () => import("./components/calendar/CalendarMonthandyear"));

Vue.component("CalendarMonthDoublePicker", () => import("./components/calendar/CalendarMonthDoublePicker"));

Vue.component("InputCalendar", () => import("./components/calendar/InputCalendar"));

Vue.component("FooterButton", () => import("./components/document/editDocument/FooterButton"));

Vue.component("ModalBox", () => import("./components/modal/ModalBox"));

Vue.component("DragAndDrop", () => import("./components/dragAndDrop/DragAndDrop"));

Vue.component("TableBox", () => import("./components/table/TableBox"));

Vue.component("SortButton", () => import("./components/table/SortButton"));

Vue.component("Skeleton", () => import("./components/skeleton/Skeleton"));

Vue.component("ActionDropdownIconMenu", () => import("./components/element/ActionDropdownIconMenu.vue"));

Vue.component("SelectPeriodComponent", () => import("./components/element/SelectPeriodComponent"));

Vue.component("SelectNetAmountComponent", () => import("./components/element/SelectNetAmountComponent"));

Vue.component("MenuEditIcon", () => import("./components/element/MenuEditIcon.vue"));
